module.exports = __webpack_public_path__ + "static/media/2 (22).1b9b2992.jpg";